import { Stack } from '@mui/material';
import React from 'react';
import CheckoutTextField from '../CheckoutTextField';
import { PaymentMethodFormProps } from './PaymentMethodForms';
export default function POForm({ settings }: PaymentMethodFormProps) {
  const label =
  settings && settings?.purchaseOrderPlaceholderEnabled
    ? settings.purchaseOrderPlaceholderText || 'PO Number'
    : 'PO Number';

  return (
    <Stack direction={'column'} spacing={2}>
      <CheckoutTextField name={'poNumber'} label={label} rules={{ required: true }} />
    </Stack>
  );
}
